import UIComponent from "../ui/component";

export class FilesBottomDrawer extends UIComponent {
    init() {
        
        // this.includeComponents({
        //     resultTabs: 'document@[data-tbx-name="resultTabs"]',
        // });

        this.actionBarEl = document.querySelector(".trigger-drawer");
        this.isViewportAnchor = this.hasAttr("data-viewport-anchor");



        if (this.actionBarEl || this.isViewportAnchor) {
            document.body.addEventListener("scroll", this.handleScroll.bind(this));
            this.handleScroll();
        }
    }

    handleScroll() {
    
        
        if (this.isViewportAnchor) {
            this.changeViewByViewport();
        } else {
            this.changeViewByEl();
        }
    }

    changeViewByEl() {
        if (!this.actionBarEl) {
            return;
        }
        
        const rect = this.actionBarEl.getBoundingClientRect();
        
        if (rect.bottom <= 0) {
            this.show();
        } else {

            this.hide();
        }
    }

    changeViewByViewport() {
        const threshold = window.innerHeight * 1.5;
        
        if (window.scrollY >= threshold) {
            this.show();
        } else {
            this.hide();
        }
    }

    show() {
        this.addClass("files-bottom-drawer--visible");
    }

    hide() {
        this.removeClass("files-bottom-drawer--visible");
    }
}